import Actionsheet from './actionsheet';
import Area from './area';
import Badge from './badge';
import BadgeGroup from './badge-group';
import Button from './button';
import Carousel from './carousel';
import CarouselItem from './carousel-item'
import Cell from './cell';
import CellGroup from './cell-group';
import CellSwipe from './cell-swipe';
import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';
import Col from './col'
import Collapse from './collapse';
import CollapseItem from './collapse-item';
import DatetimePicker from './datetime-picker';
import Dialog from './dialog';
import Field from './field';
import GoodsAction from './goods-action';
import GoodsActionBigBtn from './goods-action-big-btn';
import GoodsActionMiniBtn from './goods-action-mini-btn';
import Icon from './icon';
import Iconbutton from './icon-button';
import ImagePreview from './image-preview';
import Indicator from './indicator';
import List from './list';
import Loader from './loader';
import Locale from './locale';
import NavBar from './navbar';
import NoticeBar from './notice-bar';
import Pagination from './pagination';
import Panel from './panel';
import Picker from './picker';
import Popup from './popup';
import ProgressBar from './progress-bar';
import PullRefresh from './pull-refresh';
import Radio from './radio';
import RadioGroup from './radio-group';
import Row from './row'
import Search from './search';
import Slider from './slider';
import StepItem from './step-item';
import Stepper from './stepper';
import StepBar from './step-bar';
import Switch from './switch';
import SwitchCell from './switch-cell';
import TabItem from './tab-item';
import Tabbar from './tabbar';
import TabbarItem from './tabbar-item';
import TabGroup from './tab-group';
import Tag from './tag';
import Toast from './toast';
import Uploader from './uploader';
import FormField from './form-field'
import Input from './input'
import MultiChoice from './MultiChoice'
import BottomPlaceholder from '../combines/bottom-placeholder'
import ExPagination from '../combines/ex-pagination'
import ConfirmButtons from '../combines/confirm-buttons'

const version = '1.1.10';
const components = [
  Actionsheet,
  Area,
  Badge,
  BadgeGroup,
  Button,
  Carousel,
  CarouselItem,
  Cell,
  CellGroup,
  CellSwipe,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Icon,
  Iconbutton,
  ImagePreview,
  Indicator,
  List,
  Loader,
  Locale,
  NavBar,
  NoticeBar,
  Pagination,
  Panel,
  Picker,
  Popup,
  ProgressBar,
  PullRefresh,
  Radio,
  RadioGroup,
  Row,
  Search,
  Slider,
  StepItem,
  Stepper,
  StepBar,
  Switch,
  SwitchCell,
  TabItem,
  Tabbar,
  TabbarItem,
  TabGroup,
  Tag,
  Toast,
  Uploader,
  FormField,
  Input,
  MultiChoice,
  BottomPlaceholder,
  ExPagination,
  ConfirmButtons
];

const install = Vue => {
  components.forEach(Component => {
    Vue.use(Component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  install,
  version,
  Actionsheet,
  Area,
  Badge,
  BadgeGroup,
  Button,
  Carousel,
  CarouselItem,
  Cell,
  CellGroup,
  CellSwipe,
  Checkbox,
  CheckboxGroup,
  Col,
  Collapse,
  CollapseItem,
  DatetimePicker,
  Dialog,
  Field,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Icon,
  Iconbutton,
  ImagePreview,
  Indicator,
  List,
  Loader,
  Locale,
  NavBar,
  NoticeBar,
  Pagination,
  Panel,
  Picker,
  Popup,
  ProgressBar,
  PullRefresh,
  Radio,
  RadioGroup,
  Row,
  Search,
  Slider,
  StepItem,
  Stepper,
  StepBar,
  Switch,
  SwitchCell,
  TabItem,
  Tabbar,
  TabbarItem,
  TabGroup,
  Tag,
  Toast,
  Uploader,
  FormField,
  Input,
  MultiChoice,
  BottomPlaceholder,
  ExPagination,
  ConfirmButtons
};

export default {
  install,
  version
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/index.js